module.exports = __webpack_public_path__ + "static/media/silhouette_awards.3cee868c.webp";